window.jQuery = $;
window.$ = $;


